import { safeErr } from '../App';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLeads, getContacts, contactsToLeads, createCampaign, sendBulk, getSettings } from '../api';
const SECTORS=['All','IT & Software','Healthcare','Manufacturing','Retail','Education','Logistics','Finance','Real Estate','Food & Agri'];
const LEADS_PAGE_SIZE=25;
const CONTACTS_PAGE_SIZE=25;
export default function NewCampaign({ showToast }) {
  const [step,setStep]=useState(1);
  const [name,setName]=useState('');const [sector,setSector]=useState('All');
  const [source,setSource]=useState('leads');
  const [leads,setLeads]=useState([]);const [sel,setSel]=useState(new Set());
  const [leadsPage,setLeadsPage]=useState(1);
  const [contacts,setContacts]=useState([]);const [cLoading,setCLoad]=useState(false);
  const [contactsPage,setContactsPage]=useState(1);
  const [contactSearch,setContactSearch]=useState('');const [includeEmailed,setIncludeEmailed]=useState(false);
  const [loading,setLoad]=useState(false);const [creating,setCreate]=useState(false);const [done,setDone]=useState(false);
  const [sendingEmail,setSendingEmail]=useState('');const [forwardTo,setForwardTo]=useState('');
  const nav=useNavigate();
  useEffect(()=>{ getSettings().then(r=>{setSendingEmail(r.data.sending_email||'');setForwardTo(r.data.forward_to||'');}).catch(()=>{}); },[]);
  useEffect(()=>{
    if(step===2&&source==='leads'){
      setLoad(true);
      const params = sector==='All' ? {status:'new'} : {status:'new',sector};
      getLeads(params).then(r=>{setLeads(r.data);setSel(new Set(r.data.map(l=>l.id)));setLeadsPage(1);}).finally(()=>setLoad(false));
    }
  },[step,source,sector]);
  useEffect(()=>{
    if(step===2&&source==='contacts'){
      setCLoad(true);
      const t=setTimeout(()=>{
        getContacts({search:contactSearch,emailed:includeEmailed?'':'no',limit:200})
          .then(r=>{setContacts(r.data);setContactsPage(1);}).finally(()=>setCLoad(false));
      },300);
      return ()=>clearTimeout(t);
    }
  },[step,source,contactSearch,includeEmailed]);
  const switchSource=(s)=>{ if(s!==source){ setSource(s); setSel(new Set()); } };
  const selIds=[...sel];
  const launch=async()=>{
    if(!name||!selIds.length){showToast(`Enter name and select ${source==='contacts'?'contacts':'leads'}`,'error');return;}
    setCreate(true);
    try{
      let targetIds=selIds;
      if(source==='contacts'){
        const r=await contactsToLeads(selIds,sector==='All'?null:sector);
        targetIds=r.data.lead_ids;
      }
      await createCampaign({name,sector,lead_ids:targetIds});await sendBulk(targetIds);setDone(true);setTimeout(()=>nav('/campaigns'),1500);
    }
    catch(e){showToast(e.response?.data?.detail||'Launch failed','error');}
    finally{setCreate(false);}
  };
  const steps=[['1','Details'],['2','Select recipients'],['3','Launch']];
  return(<>
    <div className="step-bar">
      {steps.map(([n,l],i)=>(
        <React.Fragment key={n}>
          <div className={`step-item ${step>i+1?'done':''} ${step===i+1?'active':''}`}>
            <div className="step-num">{step>i+1?'✓':n}</div>{l}
          </div>
          {i<2&&<div className={`step-line ${step>i+1?'done':''}`}/>}
        </React.Fragment>
      ))}
    </div>
    {step===1&&(
      <div className="card">
        <div className="card-header"><span className="card-title">Campaign details</span></div>
        <div className="card-body">
          <div className="form-group"><label className="form-label">Campaign name</label><input className="form-input" value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. IT sector outreach June 2026"/></div>
          <div className="form-group"><label className="form-label">Target sector</label>
            <select className="form-select" value={sector} onChange={e=>setSector(e.target.value)}>
              {SECTORS.map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
          <div style={{display:'flex',gap:8}}>
            <button className="btn btn-primary" disabled={!name} onClick={()=>setStep(2)}>Continue →</button>
            <button className="btn" onClick={()=>nav('/campaigns')}>Cancel</button>
          </div>
        </div>
      </div>
    )}
    {step===2&&(
      <>
        <div style={{display:'flex',gap:8,marginBottom:12}}>
          <button className={`btn btn-sm ${source==='leads'?'btn-primary':''}`} onClick={()=>switchSource('leads')}>From leads page</button>
          <button className={`btn btn-sm ${source==='contacts'?'btn-primary':''}`} onClick={()=>switchSource('contacts')}>From contacts page</button>
        </div>
        {source==='leads'?(
          loading?<div className="loading-center"><div className="spinner spinner-md"/></div>
          :leads.length===0?<div className="alert alert-warning">No new (un-contacted) leads available{sector==='All'?'':` for sector "${sector}"`}. <button className="btn btn-sm btn-primary" onClick={()=>nav('/generate')} style={{marginLeft:8}}>Generate leads first</button></div>
          :(
            <div className="card">
              <div className="card-header">
                <span className="card-title">Select leads ({sel.size} of {leads.length} selected)</span>
                <button className="btn btn-sm" onClick={()=>setSel(sel.size===leads.length?new Set():new Set(leads.map(l=>l.id)))}>
                  {sel.size===leads.length?'Deselect all':'Select all'}
                </button>
              </div>
              <div className="table-wrap">
                <table><thead><tr><th style={{width:36}}></th><th>Name</th><th>Company</th><th>Role</th><th>Email</th></tr></thead>
                <tbody>{leads.slice((leadsPage-1)*LEADS_PAGE_SIZE,leadsPage*LEADS_PAGE_SIZE).map(l=>(
                  <tr key={l.id} className={sel.has(l.id)?'selected':''} onClick={()=>setSel(p=>{const n=new Set(p);n.has(l.id)?n.delete(l.id):n.add(l.id);return n;})}>
                    <td><input type="checkbox" checked={sel.has(l.id)} onChange={()=>{}} style={{accentColor:'var(--blue)'}}/></td>
                    <td style={{fontWeight:600}}>{l.name}</td><td>{l.company}</td>
                    <td style={{color:'var(--text-2)',fontSize:12}}>{l.role}</td>
                    <td className="mono" style={{color:'var(--text-2)',fontSize:12}}>{l.email}</td>
                  </tr>
                ))}</tbody></table>
              </div>
              {leads.length>LEADS_PAGE_SIZE&&(
                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 16px',borderTop:'1px solid var(--border)'}}>
                  <span style={{fontSize:12,color:'var(--text-2)'}}>
                    Showing {(leadsPage-1)*LEADS_PAGE_SIZE+1}–{Math.min(leadsPage*LEADS_PAGE_SIZE,leads.length)} of {leads.length}
                  </span>
                  <div style={{display:'flex',gap:6,alignItems:'center'}}>
                    <button className="btn btn-sm" disabled={leadsPage<=1} onClick={()=>setLeadsPage(p=>p-1)}>← Prev</button>
                    <span style={{fontSize:12,color:'var(--text-2)',padding:'0 6px'}}>Page {leadsPage} of {Math.ceil(leads.length/LEADS_PAGE_SIZE)}</span>
                    <button className="btn btn-sm" disabled={leadsPage>=Math.ceil(leads.length/LEADS_PAGE_SIZE)} onClick={()=>setLeadsPage(p=>p+1)}>Next →</button>
                  </div>
                </div>
              )}
            </div>
          )
        ):(
          <>
            <div style={{display:'flex',gap:12,marginBottom:12,flexWrap:'wrap',alignItems:'center'}}>
              <input className="form-input" style={{width:260}} placeholder="Search name, company or email…"
                value={contactSearch} onChange={e=>setContactSearch(e.target.value)}/>
              <label style={{display:'flex',alignItems:'center',gap:6,fontSize:13,color:'var(--text-2)',cursor:'pointer'}}>
                <input type="checkbox" checked={includeEmailed} onChange={e=>setIncludeEmailed(e.target.checked)} style={{accentColor:'var(--blue)'}}/>
                Include already-emailed contacts
              </label>
            </div>
            {cLoading?<div className="loading-center"><div className="spinner spinner-md"/></div>
            :contacts.length===0?<div className="alert alert-warning">No matching contacts found.</div>
            :(
              <div className="card">
                <div className="card-header">
                  <span className="card-title">Select contacts ({sel.size} of {contacts.length} selected)</span>
                  <button className="btn btn-sm" onClick={()=>setSel(sel.size===contacts.length?new Set():new Set(contacts.map(c=>c.id)))}>
                    {sel.size===contacts.length?'Deselect all':'Select all'}
                  </button>
                </div>
                <div className="table-wrap">
                  <table><thead><tr><th style={{width:36}}></th><th>Name</th><th>Company</th><th>Email</th><th>Status</th></tr></thead>
                  <tbody>{contacts.slice((contactsPage-1)*CONTACTS_PAGE_SIZE,contactsPage*CONTACTS_PAGE_SIZE).map(c=>(
                    <tr key={c.id} className={sel.has(c.id)?'selected':''} onClick={()=>setSel(p=>{const n=new Set(p);n.has(c.id)?n.delete(c.id):n.add(c.id);return n;})}>
                      <td><input type="checkbox" checked={sel.has(c.id)} onChange={()=>{}} style={{accentColor:'var(--blue)'}}/></td>
                      <td style={{fontWeight:600}}>{c.name}</td><td>{c.company}</td>
                      <td className="mono" style={{color:'var(--text-2)',fontSize:12}}>{c.email}</td>
                      <td>{c.emailed?<span className="pill pill-blue" style={{fontSize:10}}>✉ Emailed</span>:<span style={{color:'var(--text-2)',fontSize:11}}>—</span>}</td>
                    </tr>
                  ))}</tbody></table>
                </div>
                {contacts.length>CONTACTS_PAGE_SIZE&&(
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 16px',borderTop:'1px solid var(--border)'}}>
                    <span style={{fontSize:12,color:'var(--text-2)'}}>
                      Showing {(contactsPage-1)*CONTACTS_PAGE_SIZE+1}–{Math.min(contactsPage*CONTACTS_PAGE_SIZE,contacts.length)} of {contacts.length}
                    </span>
                    <div style={{display:'flex',gap:6,alignItems:'center'}}>
                      <button className="btn btn-sm" disabled={contactsPage<=1} onClick={()=>setContactsPage(p=>p-1)}>← Prev</button>
                      <span style={{fontSize:12,color:'var(--text-2)',padding:'0 6px'}}>Page {contactsPage} of {Math.ceil(contacts.length/CONTACTS_PAGE_SIZE)}</span>
                      <button className="btn btn-sm" disabled={contactsPage>=Math.ceil(contacts.length/CONTACTS_PAGE_SIZE)} onClick={()=>setContactsPage(p=>p+1)}>Next →</button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
        <div style={{display:'flex',gap:8,marginTop:8}}>
          <button className="btn btn-primary" disabled={!sel.size} onClick={()=>setStep(3)}>Continue →</button>
          <button className="btn" onClick={()=>setStep(1)}>← Back</button>
        </div>
      </>
    )}
    {step===3&&(
      <div className="card">
        <div className="card-header"><span className="card-title">Review & launch</span></div>
        <div className="card-body">
          {[['Campaign name',name],['Sector',sector],
            ['Source',source==='contacts'?'Contacts page':'Leads page'],['Leads to email',selIds.length],
            ['Sending from',sendingEmail],['Replies forwarded to',forwardTo],
            ['Follow-up delay','3 days'],['Max follow-ups','3 emails']].map(([l,v])=>(
            <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'9px 0',borderBottom:'1px solid var(--border)',fontSize:13}}>
              <span style={{color:'var(--text-2)',fontWeight:500}}>{l}</span>
              <span style={{fontWeight:600}}>{v}</span>
            </div>
          ))}
          <div style={{display:'flex',gap:8,marginTop:16}}>
            {done?<div className="alert alert-success">✓ Campaign launched! Redirecting…</div>:(
              <>
                <button className="btn btn-primary" disabled={creating} onClick={launch}>
                  {creating?<><span className="spinner spinner-sm"/>Launching…</>:'🚀 Launch campaign'}
                </button>
                <button className="btn" onClick={()=>setStep(2)}>← Back</button>
              </>
            )}
          </div>
        </div>
      </div>
    )}
  </>);
}
